import { render } from "./ScheduleItem.vue?vue&type=template&id=22747fd3&scoped=true"
import script from "./ScheduleItem.vue?vue&type=script&lang=js"
export * from "./ScheduleItem.vue?vue&type=script&lang=js"

import "./ScheduleItem.vue?vue&type=style&index=0&id=22747fd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22747fd3"]])

export default __exports__